import { Injectable, signal, WritableSignal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonMapService {
  private selectedItem: WritableSignal<string> = signal('');
  private dataSubject = new BehaviorSubject<any[]>([]);
  
  data$ = this.dataSubject.asObservable();

  updateData(data: any[]) {
    this.dataSubject.next(data);
  }

  setSelectedItem(selectedItem: string) {
    this.selectedItem.set(selectedItem);
  }

  getSelectedItem() {
    return this.selectedItem();
  }
}